// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"styles_sidebar__3hw-4","filter":"styles_filter__2f1mt","title":"styles_title__159VF"};